import React, { memo } from 'react';
import { useSelector } from 'react-redux';
import ConfirmationModal from '../../ConfirmationModal';
import {
  getDeviceLockModalConfig,
  resolveEngineeringLockState,
} from '../../../utils/engineeringLockUtils';

const DeviceLockRequiredModal = memo(({
  isOpen,
  onCancel,
  onConfirm,
  confirmBtnText = 'Lock & Edit',
}) => {
  const engineeringLockState = useSelector(
    state => state.AppState.boxDetails.engineeringLock,
  );
  const box = useSelector(state => state.AppState.boxDetails.box);
  const user = useSelector(state => state.AppState.user);
  const engineeringLock = resolveEngineeringLockState(engineeringLockState, box);
  const config = getDeviceLockModalConfig(
    user,
    engineeringLock,
    box,
    confirmBtnText,
  );

  return (
    <ConfirmationModal
      key={config.warning ? 'engineering-lock-warning' : 'device-lock-required'}
      isOpen={isOpen}
      onCancel={onCancel}
      onConfirm={onConfirm}
      bodyText={config.bodyText}
      headerText={config.headerText}
      confirmBtnText={config.confirmBtnText}
      warning={config.warning}
      ignoreConfirmButton={config.ignoreConfirmButton}
      close={config.close}
      closeBtnText={config.closeBtnText}
    />
  );
});

export default DeviceLockRequiredModal;
